import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "#/stores/auth";
import { canViewWorkflows, canManageUsers } from "#/server/utils/auth/roles";

export function RequireAuth({ children }: { children: React.ReactNode }) {
	const user = useAuthStore((state) => state.user);
	const isLoading = useAuthStore((state) => state.isLoading);
	const location = useLocation();

	// Still checking auth status
	if (isLoading) return <div>Loading...</div>;

	// Not authenticated - redirect to login
	if (!user) {
		return <Navigate to="/login" state={{ from: location.pathname }} replace />;
	}

	return children as React.ReactElement;
}

export function RequireWorkflowAccess({ children }: { children: React.ReactNode }) {
	const user = useAuthStore((state) => state.user);
	const location = useLocation();
	const allowed = canViewWorkflows(user?.roles || []);
	if (!allowed) return <Navigate to={"/"} state={{ from: location.pathname }} replace />;
	return children as React.ReactElement;
}

export function RequireUserAdmin({ children }: { children: React.ReactNode }) {
	const user = useAuthStore((state) => state.user);
	const location = useLocation();
	const allowed = canManageUsers(user?.roles || []);
	if (!allowed) return <Navigate to={"/"} state={{ from: location.pathname }} replace />;
	return children as React.ReactElement;
}
